import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Service worker registration disabled to avoid caching and asset path issues.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
